module.exports = __webpack_public_path__ + "img/close.53b65a02.png";